export const trimSearchParams = (urlPath: string): string => {
  const searchParamIndex = urlPath.indexOf('?');

  return searchParamIndex === -1 ? urlPath : urlPath.substring(0, searchParamIndex);
};
